<script setup lang="ts">
import { ButtonType, type LabelledValue, type MultiConfirmOptions } from 'vince-ui/types/common';
import { getConfirm } from 'vince-ui/utils/dialogHelpers';

const value = ref<string>('');
const cancelButtonLabel = ref<string>('');
const confirmOptions = ref<LabelledValue[]>([]);
const group = `multi-option-confirm-${useId()}`;

const show = ({ message, header, icon, options, cancelLabel }: MultiConfirmOptions) => {
    cancelButtonLabel.value = cancelLabel;
    confirmOptions.value = options;
    return new Promise((resolve, reject) => {
        getConfirm().require({
            message,
            header,
            icon,
            group,
            modal: true,
            reject: () => {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject();
            },
            accept: () => {
                resolve(value.value);
            }
        });
    });
};

defineExpose({ show });

</script>

<template>
    <VLConfirmDialog :group="group">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div class="flex flex-col items-center p-8 rounded">
                <div
                    class="rounded-full bg-green-600 inline-flex justify-center items-center h-24 w-24 -mt-20"
                >
                    <i class="pi pi-question !text-4xl text-white" />
                </div>

                <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>

                <p class="mb-0">
                    {{ message.message }}
                </p>

                <div class="flex items-center gap-2 mt-6">
                    <VButton
                        v-for="(o, index) in confirmOptions"
                        :key="index"
                        :label="o.label"
                        @click="() => {value = o.value; acceptCallback()}"
                    />
                    <VButton :label="cancelButtonLabel" :type="ButtonType.OUTLINE_PRIMARY" @click="rejectCallback" />
                </div>
            </div>
        </template>
    </VLConfirmDialog>
</template>
